
import React, { useState } from "react";
//import axios from "axios";
import axios from './AxiosInstance';
import { useNavigate } from "react-router-dom";
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  Alert,
} from "@mui/material";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  // const handleLogin = async (e) => {
  //   e.preventDefault();
  //   try {
  //     const res = await axios.post("http://localhost:5000/login", {
  //       username,
  //       password,
  //     });
  //     //console.log("🚀 Server response:", res.data);
  //    // console.log(res.data.user.mqtt_username);
  //     if (res.data.token) {
  //       sessionStorage.setItem(`token_${username}`, res.data.token);
  //       sessionStorage.setItem("currentUser", username)
  //       sessionStorage.setItem("mqttUser", res.data.mqtt_username);
  //       sessionStorage.setItem("password", password); 
  //       console.log("✅ MQTT Username received:", res.data.mqtt_username);
  //       //console.log(res.data.user.mqtt_username);
  //       navigate("/dashboard");
  //     }
  //   } catch (err) {
  //     setError(err.response?.data?.message || "Login failed");
  //   }
  // };
  const handleLogin = async (e) => {
    e.preventDefault();
    // try {
    //   const res = await axios.post("http://localhost:5000/login", {
    //     username,
    //     password,
    //   });


    try {
      const res = await axios.post('/api/login', {
        username,
        password,
      });
      if (res.data) {
        console.log("login section");
        sessionStorage.setItem("currentUser", username); // Optional for frontend tracking
        sessionStorage.setItem(`token_${username}`, res.data.token);
        sessionStorage.setItem("userType", res.data.usertype);
        console.log("userType",res.data.usertype);
                sessionStorage.setItem("mqttUser", res.data.mqtt_username);
        sessionStorage.setItem("password", password); 
        console.log("✅ MQTT Username received:", res.data.mqtt_username);
        //console.log(res.data.user.mqtt_username);

        navigate("/dashboard");
        console.log('dahboard............')
      }
    } catch (err) {
      setError(err.response?.data?.message || "Login failed");
    }
  };
  return (
    <Box
      sx={{
        height: "80vh",
        backgroundColor: "#f5f5f5",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Paper elevation={3} sx={{ padding: 4, width: 380 }}>
        <Typography variant="h5" gutterBottom align="center">
          Login
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <form onSubmit={handleLogin}>
          <TextField
            label="Username"
            variant="outlined"
            fullWidth
            required
            margin="normal"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />

          <TextField
            label="Password"
            type="password"
            variant="outlined"
            fullWidth
            required
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2 }}
          >
            Login
          </Button>
        </form>
      </Paper>
    </Box>
  );
};

export default Login;
